import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Modal from '@mui/material/Modal';

import CrmButton from './CrmButton';

const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    root: {
      width: '400px',
      margin: '160px auto 0',
    },
    button: {
      float: 'right',
    },
  })
);

export default function AlertModal({ show, renderer, title, text, closeFunc }) {
  const classes = useStyles();

  const closeDialog = () => {
    if (renderer) {
      renderer.setState({ shouldShowAlertModal: false });
    } else {
      closeFunc('');
    }
  };

  const titleText = title || 'Notice';

  return (
    <div>
      <Modal className={classes.root} open={!!show} onClose={closeDialog}>
        <div className={classes.paper}>
          <h4>{titleText}</h4>
          <p>{text}</p>
          <CrmButton className={classes.button} filled onClick={closeDialog}>
            OK
          </CrmButton>
        </div>
      </Modal>
    </div>
  );
}
